import React from 'react';
import { Form, Input } from 'antd';
import { PATIENT_NUMBER_FIELD } from '../../utils/portalTurnSecurity';
import './PatientNumberField.scss';

export default function PatientNumberField() {
  return (
    <div className="form-spacer" aria-hidden="true">
      <Form.Item name={PATIENT_NUMBER_FIELD} noStyle>
        <Input autoComplete="new-password" tabIndex={-1} />
      </Form.Item>
    </div>
  );
}
